import { Panel } from '@watcherr/ui';
import * as React from 'react';
import PermissionTable from '~/components/PermissionTable';

const PermissionsOverviewContainer = () => {
  return (
    <Panel>
      <Panel.Title>General permissions</Panel.Title>
      <PermissionTable
        permissions={[
          { id: 1, name: 'Login' },
          { id: 2, name: 'Reset passwords' },
        ]}
      />
    </Panel>
  );
};

export default PermissionsOverviewContainer;
